import { AutogenLayoutOfficeDeductHistTable } from "./autogen/AutogenLayoutOfficeDeductHistTable";
import { OpenType } from "@mcleod/components";

export class OfficeDeductHistTable extends AutogenLayoutOfficeDeductHistTable {
    onLoad(): void | Promise<void> {
        this.tableDeduction.crudManager.defaultOpenType = OpenType.NEW_TAB_WITH_SWITCH;
    }
}
